var MuiDrawer = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'visible',
    },
    paperAnchorBottom: {
        minHeight: '90vh',
        maxHeight: '90vh',
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
        overflow: 'visible',
    },
    paperAnchorTop: {
        minHeight: '90vh',
        maxHeight: '90vh',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
        overflow: 'visible',
    },
    paperAnchorLeft: {
        minWidth: '90vw',
        maxWidth: '90vw',
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        overflow: 'visible',
    },
    paperAnchorRight: {
        minWidth: '90vw',
        maxWidth: '90vw',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        overflow: 'visible',
    },
};
export default MuiDrawer;
//# sourceMappingURL=MuiDrawer.js.map